export default (): boolean => {
  return window.matchMedia && window.matchMedia('(hover: none)').matches
}
